'use client';

import { useMemo } from 'react';
import SmartLink from '@/components/utils/SmartLink';

type BannerFields = {
    text?: string;
    link?: { url?: string; target?: string; title?: string };
    promotionText?: string;
    promotionLink?: { url?: string; target?: string; title?: string };
    startDate?: string;
    endDate?: string;
};

export default function SlidingBannerClient({ fields }: { fields: BannerFields }) {
    const isPromotionActive = useMemo(() => {
        if (!fields.promotionText || !fields.promotionLink?.url || !fields.startDate || !fields.endDate) {
            return false;
        }
        const now = new Date();
        return now >= new Date(fields.startDate) && now <= new Date(fields.endDate);
    }, [fields]);

    const bannerText = isPromotionActive ? fields.promotionText! : (fields.text || '');
    const bannerLink = isPromotionActive ? fields.promotionLink!.url! : (fields.link?.url || '');

    if (!bannerText || !bannerLink) {
        return null;
    }

    return (
        <div
            className="relative w-full overflow-hidden text-white py-2"
            style={{
                background: isPromotionActive
                    ? 'linear-gradient(to right, #f16232, #e04510)'
                    : 'linear-gradient(to right, #2563eb, #9333ea)',
            }}
        >
            <div className="flex w-max animate-scroll will-change-transform whitespace-nowrap text-sm sm:text-base">
                {[...Array(2)].map((_, loopIndex) => (
                    <div key={loopIndex} className="flex">
                        {[...Array(4)].map((_, i) => (
                            <div key={`${loopIndex}-${i}`} className="flex items-center shrink-0 px-8">
                                <SmartLink
                                    href={bannerLink}
                                    className="font-semibold text-white/90 hover:text-white hover:underline transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 rounded"
                                    aria-label={bannerText}
                                >
                                    {bannerText}
                                </SmartLink>
                                <span className="mx-8 text-white/50"></span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
